export default __webpack_public_path__ + "static/devops_a1_cloud_simon_j-ae14316f1fd4c7d19ed3fa24d8a51f20.jpg";